// import React, { useEffect, useState } from "react";
// import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
// import NoData from "../../NoData";
// import ChartLoader from '../../ChartLoader';
// import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
// import WaterMark from "../../DashboardMain_Orion/WaterMark";
// import { BsZoomIn } from "react-icons/bs";
// import { Bar } from "react-chartjs-2";
// import CommanBarTable_Orion from "../CommanBarTable_Orion";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   scales
// } from "chart.js";
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );
// let Maxchartdata
// let res_result

// function RateOfChargeCycles_Orion({ apiend, gloablfilter, type }) {
//   const [chartdata, setChartData] = useState([]);
//   const { isLoading, error, sendReq: fetchData } = useHttp();
//   const [chartname, SetChartName] = useState("Rate of charge");
//   let barcolor
//   let toPush = [];
//   let toPushfast = [];
//   const appyDataCycles = (data) => {
//     res_result = data;
//     toPush = [];
//     let responce = {
//       "<=10": 0,
//       "15": 0,
//       "20": 0,
//       "25": 0,
//       "30": 0,
//       "35": 0,
//       "40": 0,
//       "45": 0,
//       "50": 0,
//       "55": 0,
//       "60": 0,
//       "65": 0,
//       "70": 0,
//       ">70": 0,
//     }

//     if (res_result.length !== 0) {
//       let d = res_result[0];

//       if (d.B1.value)
//         responce["<=10"] = d.B1.value
//       if (d.B2.value)
//         responce["15"] = d.B2.value
//       if (d.B3.value)
//         responce["20"] = d.B3.value
//       if (d.B4.value)
//         responce["25"] = d.B4.value
//       if (d.B5.value)
//         responce["30"] = d.B5.value
//       if (d.B6.value)
//         responce["35"] = d.B6.value
//       if (d.B7.value)
//         responce["40"] = d.B7.value
//       if (d.B8.value)
//         responce["45"] = d.B8.value
//       if (d.B9.value)
//         responce["50"] = d.B9.value
//       if (d.B10.value)
//         responce["55"] = d.B10.value
//       if (d.B11.value)
//         responce["60"] = d.B11.value
//       if (d.B12.value)
//         responce["65"] = d.B12.value
//       if (d.B13.value)
//         responce["70"] = d.B13.value
//       if (d.B14.value)
//         responce[">70"] = d.B14.value

//       toPush.push(d.B1.value)
//       toPush.push(d.B2.value)
//       toPush.push(d.B3.value)
//       toPush.push(d.B4.value)
//       toPush.push(d.B5.value)
//       toPush.push(d.B6.value)
//       toPush.push(d.B7.value)
//       toPush.push(d.B8.value)
//       toPush.push(d.B9.value)
//       toPush.push(d.B10.value)
//       toPush.push(d.B11.value)
//       toPush.push(d.B12.value)
//       toPush.push(d.B13.value)
//       toPush.push(d.B14.value)

//       let res_result_final = [["Element", "Count", { role: "style" }]]
//       let loop_keys = Object.keys(responce);

//       loop_keys = ["<=10", "15", "20", "25", "30", "35", "40", "45", "50", "55", "60", "65", "70", ">70"]
//       let countcheck = 0
//       for (const key in responce) {
//         if (responce[key] > 0) {
//           countcheck = countcheck + 1
//         }
//       }
//       loop_keys.map(x => {
//         if (countcheck)
//           // barcolor
//           res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
//       })

//       const labels = ["<=10", "15", "20", "25", "30", "35", "40", "45", "50", "55", "60", "65", "70", ">70"]
//       Maxchartdata = {
//         labels,
//         datasets: [
//           {
//             label: "SoC(%) per Hour",
//             data: responce,
//             backgroundColor: barcolor,
//             borderWidth: 1,
//             borderColor: "black",
//           },
//         ]
//       };
//       setChartData((prestate) => res_result_final);
//     } else {
//       setChartData((prestate) => []);
//     }
//   }

//   const options1 = {
//     responsive: true,
//     categoryPercentage: 1.0,
//     barPercentage: 1.0,
//     scales: {
//       x: {
//         grid: {
//           color: 'white',
//         },
//         title: {
//           display: true,
//           text: 'SoC(%) per Hour'
//         },
//         suggestedMin: 0,
//         ticks: {
//           autoSkip: false,
//           maxRotation: 0,
//           minRotation: 0,
//         }
//       },

//       y: {
//         grid: {
//           color: 'white',
//         },
//         title: {
//           display: true,
//           text: 'Charging Cycles'
//         },
//         suggestedMin: 0,
//       },
//     },

//     plugins: {
//       legend: {
//         display: false
//       },
//     }
//   }

//   const options = {
//     hAxis: {
//       gridlines: {
//         color: 'transparent'
//       },
//       title: 'SoC(%) per Hour',
//       minValue: 0,
//       format: 'short',
//       direction: 1,
//       slantedText: true,
//       slantedTextAngle: 90
//     },

//     vAxis: {
//       gridlines: {
//         color: 'transparent'
//       },
//       title: 'Charging Cycles',
//       minValue: 0,
//       format: 'short',

//     },
//     bar: { groupWidth: "100%" },
//     legend: "none",
//     isStacked: false,
//     series: {
//       0: { color: "#3578b0" },
//     },
//   };

//   useEffect(() => {
//     fetchData({ url: API_URL_MAIN + "orion_charging_analysis/" + apiend, body: { filterdata: gloablfilter } }, appyDataCycles)
//     barcolor = "#3578b0"
//     SetChartName("Rate of charge");
//   }, [gloablfilter, type])

//   const [toPushPopUp, settoPushPopUp] = useState([]);
//   const appyDataClick = (data) => {
//     let toPushPopUpArr = []
//     let hits = data;

//     hits.map((i, key) => {
//       toPushPopUpArr.push({
//         "key": {
//           "vehicleId": i.key.vehicleId,
//           "Depot_Name": i.key.Depot_Name,
//           "DLR_ORG_CITY": i.key.DLR_ORG_CITY,
//           "vehicle_registration_number": i.key.vehicle_registration_number
//         },
//         "doc_count": 9,
//         "median_roc": {
//           "values": {
//             "50.0": i.doc_count
//           }
//         }
//       })
//     })
//     toPushPopUpArr.sort((a, b) => b.median_roc.values["50.0"] - a.median_roc.values["50.0"]);
//     settoPushPopUp(toPushPopUpArr)
//   }

//   return (
//     <>
//       <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
//             </div>
//             <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
//               {
//                 (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
//                   : <NoData />
//                 )}
//             </div>
//           </div>
//         </div>
//       </div>
//       <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

//       <WaterMark />

//       {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
//         {
//           eventName: "select",
//           callback({ chartWrapper }) {
//             const chart = chartWrapper.getChart()
//             const selection = chart.getSelection()
//             const [selectedItem] = selection;
//             const { row } = selectedItem;
//             const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);

//             let from_bucket;
//             let to_bucket;
//             const count = chartWrapper.getDataTable().Wf[row].c[1].v;
//             if (count !== 0) {
//               if (barvalue === "<=10") {
//                 from_bucket = 0
//                 to_bucket = 10
//               } else if (barvalue === ">70") {
//                 from_bucket = 70
//                 to_bucket = null
//               } else {
//                 from_bucket = barvalue - 5
//                 to_bucket = barvalue
//               }

//               fetchData({ url: API_URL_MAIN + "orion_charging_analysis/roc_cycles_click", body: { filterdata: gloablfilter, type: "Slow", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)
//               window.$('#exampleModal__' + apiend).modal('show');
//             }
//           }
//         }
//       ]}
//       /> : <NoData />)}

//       <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
//             </div>
//             {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
//             <div className="modal-body">
//               {/* <table className="table table-striped">
//                 <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
//                   <tr>
//                     <th scope="col">Vin Number</th>
//                     <th scope="col">Cycles Count</th>
//                   </tr></thead>
//                 <tbody> */}
//               <CommanBarTable_Orion data={toPushPopUp} tabDataKey={"median_roc"} />
//               {/* </tbody></table> */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default RateOfChargeCycles_Orion;

import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http";
import { Chart } from "react-google-charts";
import NoData from "../../NoData";
import ChartLoader from "../../ChartLoader";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
import WaterMark from "../../DashboardMain_Orion/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import CommanBarTable_Orion from "../CommanBarTable_Orion";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

let Maxchartdata;
let res_result;

function RateOfChargeCycles_Orion({ apiend, gloablfilter, type }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState("Rate of charge");

  // *** FIXED 8-BIN ORDER ***
  const labels = ["<10", "20", "30", "40", "50", "60", "70", ">70"];

  const appyDataCycles = (data) => {
    res_result = data;

    if (!res_result.length) {
      setChartData([]);
      return;
    }

    let d = res_result[0];

    // *** FIXED RESPONSE MAPPING (ONLY 8 BINS) ***
    let responce = {
      "<10": d.B1?.value ?? 0,
      "20": d.B2?.value ?? 0,
      "30": d.B3?.value ?? 0,
      "40": d.B4?.value ?? 0,
      "50": d.B5?.value ?? 0,
      "60": d.B6?.value ?? 0,
      "70": d.B7?.value ?? 0,
      ">70": d.B8?.value ?? 0,
    };

    // Google chart formatting
    let res_result_final = [["Element", "Count", { role: "style" }]];

    labels.forEach((l) => {
      res_result_final.push([l, responce[l], "stroke-width: 1;stroke-color: black;"]);
    });

    // ChartJS dataset *** FIXED TO ARRAY ***
    Maxchartdata = {
      labels,
      datasets: [
        {
          label: "SoC(%) per Hour",
          data: labels.map((k) => responce[k]), // FIXED
          backgroundColor: "#3578b0",
          borderWidth: 1,
          borderColor: "black",
        },
      ],
    };

    setChartData(res_result_final);
  };

  const options1 = {
    responsive: true,
    scales: {
      x: {
        ticks: { autoSkip: false, maxRotation: 0, minRotation: 0 },
      },
      y: {},
    },
    plugins: { legend: { display: false } },
  };

  const options = {
    hAxis: {
      title: "SoC(%) per Hour",
      slantedText: true,
      slantedTextAngle: 90,
    },
    vAxis: { title: "Charging Cycles" },
    legend: "none",
    series: { 0: { color: "#3578b0" } },
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "orion_charging_analysis/" + apiend,
        body: { filterdata: gloablfilter },
      },
      appyDataCycles
    );
    SetChartName("Rate of charge");
  }, [gloablfilter, type]);

  const [toPushPopUp, settoPushPopUp] = useState([]);

  const appyDataClick = (data) => {
    let arr = [];

    data.forEach((i) => {
      arr.push({
        key: {
          vehicleId: i.key.vehicleId,
          Depot_Name: i.key.Depot_Name,
          DLR_ORG_CITY: i.key.DLR_ORG_CITY,
          vehicle_registration_number: i.key.vehicle_registration_number,
        },
        doc_count: i.doc_count,
        median_roc: {
          values: { "50.0": i.doc_count },
        },
      });
    });

    arr.sort((a, b) => b.median_roc.values["50.0"] - a.median_roc.values["50.0"]);
    settoPushPopUp(arr);
  };

  return (
    <>
      {/* ZOOM Modal */}
      <div
        className="modal fade"
        id={apiend + "_modal"}
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: "400px" }}>
              {isLoading ? (
                <ChartLoader />
              ) : chartdata.length > 1 ? (
                <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>
      </div>

      <strong
        className="Zoom_first_page d-flex justify-content-end"
        style={{ cursor: "pointer" }}
        data-bs-toggle="modal"
        data-bs-target={"#" + apiend + "_modal"}
      >
        <BsZoomIn />
      </strong>

      <WaterMark />

      {/* Default Google Chart */}
      {isLoading ? (
        <ChartLoader />
      ) : chartdata.length > 1 ? (
        <Chart
          chartType="ColumnChart"
          width="100%"
          height="230px"
          data={chartdata}
          options={options}
          chartEvents={[
            {
              eventName: "select",
              callback: ({ chartWrapper }) => {
                const chart = chartWrapper.getChart();
                const selection = chart.getSelection();
                if (!selection.length) return;

                const { row } = selection[0];
                const barLabel = chartWrapper.getDataTable().Wf[row].c[0].v;
                const count = chartWrapper.getDataTable().Wf[row].c[1].v;

                if (count === 0) return;

                let from_bucket = 0;
                let to_bucket = 0;

                if (barLabel === "<10") {
                  from_bucket = 0;
                  to_bucket = 10;
                } else if (barLabel === ">70") {
                  from_bucket = 70;
                  to_bucket = null;
                } else {
                  from_bucket = parseInt(barLabel) - 10;
                  to_bucket = parseInt(barLabel);
                }

                fetchData(
                  {
                    url: API_URL_MAIN + "orion_charging_analysis/roc_cycles_click",
                    body: {
                      filterdata: gloablfilter,
                      type: "Slow",
                      from_bucket,
                      to_bucket,
                    },
                  },
                  appyDataClick
                );

                window.$("#exampleModal__" + apiend).modal("show");
              },
            },
          ]}
        />
      ) : (
        <NoData />
      )}

      {/* Click Modal */}
      <div
        className="modal fade"
        id={"exampleModal__" + apiend}
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <div className="modal-body">
              <CommanBarTable_Orion data={toPushPopUp} tabDataKey={"median_roc"} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RateOfChargeCycles_Orion;
